import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { MenuModule } from 'primeng/menu';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxPipesModule } from '../../pipes/mx.pipes.module';
import { SzDataTableComponent } from './sz-data-table/sz-data-table.component';
import { MxDialogModule } from '../mx.dialog/mx.dialog.module';
import { SzDetailPaneComponent } from './sz-detail-pane.component';
import { SzIssueReportDialogComponent } from './sz-issue-report-dialog/sz-issue-report-dialog.component';
import { SZ_UI_COMPONENTS } from './sz-ui.components';

/** A Szirom design közös építőelemei (chip, KPI, fejléc, pill-szűrő, infósáv, idővonal, üres állapot, lista-tábla, részletező). */
@NgModule({
  imports: [CommonModule, FormsModule, I18NextModule, PrimengModule, MenuModule, MxPipesModule, MxDialogModule],
  declarations: [...SZ_UI_COMPONENTS, SzDataTableComponent, SzDetailPaneComponent, SzIssueReportDialogComponent],
  exports: [...SZ_UI_COMPONENTS, SzDataTableComponent, SzDetailPaneComponent, SzIssueReportDialogComponent],
})
export class SzUiModule {}
